import React from 'react';
import { Col } from 'antd';
import { renderSearchBoxItemJob, showItemJobText } from '../../../utils/utils';
import { SEARCH_TYPE } from '../../../config/constants';
import FormDialogJob from '../FormDialogJob';
import IconItemJob from './index';
import ListItem from '@material-ui/core/ListItem';

const styleWrap = {
  fontSize: '95%',
  fontColor: 'var(--emperor)',
  fontFamily: '"Times New Roman", Times, serif, ヒラギノ角ゴ ProN',
};

function RenderSearchBoxElement({ itemJobResources, valueObj, onchangeDataItems, onchangeDataItemRange, option = {}, styles }) {
  const { itemParent, resourceChildren } = renderSearchBoxItemJob(itemJobResources);

  // Display List Profile Group and sorting by profileOrder that is used in Profile screen
  return Object.keys(itemParent)
    .sort((a, b) => itemParent[a].searchOrder - itemParent[b].searchOrder)
    .map((profile, key) => {
      // 1
      if (Number(itemParent[profile].searchType) === SEARCH_TYPE.DROPDOWN) {
        return (
          <React.Fragment key={key}>
            <Col xs={12} style={{ padding: '3px 0 0 0' }} className="d-ant-col mt-10">
              {option && option.icon && <IconItemJob item={profile} />}
              <span style={styleWrap} className="font-2">{itemParent[profile]?.title}</span>
            </Col>
            <Col xs={12} style={{ display: 'flex', justifyContent: 'center', padding: '1px 0 4px' }}>
              <ListItem style={{ padding: 0 }}>
                <div className="d-item-box-search">
                  <div className="d-text-right" style={{ width: '100%', position: 'relative' }}>
                    <FormDialogJob
                      namelabel={itemParent[profile]?.title}
                      values={valueObj?.items[profile] || []}
                      resource={resourceChildren[profile]}
                      onchangeData={(e) => onchangeDataItems(e, profile)}
                      multi={false}
                      typeSearch={SEARCH_TYPE.DROPDOWN}
                      text={showItemJobText(resourceChildren[profile], valueObj?.items[profile])}
                    />
                  </div>
                </div>
              </ListItem>
            </Col>
          </React.Fragment>
        );
      }

      // 2
      if (Number(itemParent[profile].searchType) === SEARCH_TYPE.CHECKBOX) {
        return (
          <React.Fragment key={key}>
            <Col xs={12} style={{ padding: '3px 0 0 0' }} className="d-ant-col mt-10">
              {option && option.icon && <IconItemJob item={profile} />}
              <span style={styleWrap} className="font-2">{itemParent[profile]?.title}</span>
            </Col>
            <Col xs={12} style={{ padding: '1px 0 4px' }}>
              <div className="d-item-box-search-text">
                <FormDialogJob
                  values={valueObj?.items[profile] || []}
                  namelabel={itemParent[profile]?.title}
                  nametext={profile}
                  typeSearch={SEARCH_TYPE.CHECKBOX}
                  resource={resourceChildren[profile]}
                  multi={true}
                  onchangeData={(e, name, k) => onchangeDataItems(e, name, k)}
                  text={showItemJobText(resourceChildren[profile], valueObj?.items[profile], profile)}
                />
              </div>
            </Col>
          </React.Fragment>
        );
      }

      // 3
      if (Number(itemParent[profile].searchType) === SEARCH_TYPE.RANGE) {
        return (
          <React.Fragment key={key}>
            <div key={key}>
              <ListItem className={`d-ant-col font-2`} style={{  padding: '4px 0 0px 0' }}>
                {option && option.icon && <IconItemJob item={profile} />}
                <span style={styleWrap} className="font-2">{itemParent[profile]?.title}</span>
              </ListItem>
              <ListItem style={{ padding: "0 0 4px 0" }}>
                <div className="d-item-box-search d-flex justify-content-center">
                  <div className="d-range-left" style={{ width: '100%', position: 'relative' }}>
                    <FormDialogJob
                      values={valueObj?.itemRange[`${profile}_from`] || []}
                      namelabel={itemParent[profile]?.title}
                      nametext={`${profile}_from`}
                      typeSearch={SEARCH_TYPE.RANGE}
                      resource={resourceChildren[profile]}
                      onchangeData={(e, name, k) => onchangeDataItemRange(e, name, k)}
                      text={showItemJobText(resourceChildren[profile], valueObj?.itemRange[`${profile}_from`], `${profile}_from`)}
                      multi={false}
                    />
                  </div>
                  <div className="d-symbol-range">~</div>
                  <div className="d-range-right" style={{ width: '100%', position: 'relative' }}>
                    <FormDialogJob
                      values={valueObj?.itemRange[`${profile}_to`] || []}
                      namelabel={itemParent[profile]?.title}
                      nametext={`${profile}_to`}
                      typeSearch={SEARCH_TYPE.RANGE}
                      resource={resourceChildren[profile]}
                      onchangeData={(e, name, k) => onchangeDataItemRange(e, name, k)}
                      text={showItemJobText(resourceChildren[profile], valueObj?.itemRange[`${profile}_to`], `${profile}_to`)}
                      multi={false}
                    />
                  </div>
                </div>
              </ListItem>
            </div>
          </React.Fragment>
        );
      }
    });
}

export default RenderSearchBoxElement;
